import { css, Global } from '@emotion/react';
import '@mis/sushi-tailwind-react/dist/sushi.css';
import React from 'react';
import 'react-toggle/style.css';
import 'react-tooltip/dist/react-tooltip.css';
import { GlobalStyles as BaseStyles } from 'twin.macro';
import './override-scrollbar.css';
import './override-tabs.css';
import './override-input.css';
import './override-popup-z-index.css';
import SVGColor from './svg-color';

const customStyles = css([
  {
    body: {
      backgroundColor: '#f3f3f3',
    },
  },
]);

const GlobalStyles = (): React.ReactElement => (
  <>
    <BaseStyles />
    <Global styles={customStyles} />
    <SVGColor />
  </>
);

export default GlobalStyles;
